import React, { useState } from 'react';
import { Box, Button, Typography, Stack, TextField } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import PhoneNumber from '../../dao/PhoneNumber';
import MessageTemplate from '../../dao/MessageTemplate';

export default function TemplateSample({
  body,
  setBody,
  header,
  setHeader,
  headerImage,
  setHeaderImage,
}) {
  const [loadingUpload, setLoadingUpload] = useState(false);
  const { waba_id } = useParams();

  const bodySampleCount = () => {
    const parameter = body.text.match(/\{{\d+}}/g);
    return parameter ?? [];
  };

  const headerSampleCount = () => {
    const parameter = header.text.match(/\{{\d+}}/g);
    return parameter ?? [];
  };

  const handleUploadClick = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = typeHeader[header.format].format;
    input.onchange = async (e) => {
      try {
        setLoadingUpload(true);
        const file = e.target.files[0];
        let formData = new FormData();
        formData.append('folder', 'wa_panel');
        formData.append('directory', 'wa_panel');
        formData.append('public', true);
        formData.append('files', file);
        let url = await PhoneNumber.postImage(formData);

        setHeaderImage(url.data[0]?.url);

        let phone = await PhoneNumber.getAll(waba_id);
        // console.log('phone', phone[0]?.display_phone_number);

        const phoneNum = phone[0].display_phone_number.replace(/\D/g, '');

        phone[0].display_phone_number = phone[0].display_phone_number.substring(
          phone[0].display_phone_number.indexOf(' ') + 1
        );

        let fetchNumId = phoneNum.replace('-');

        let key = await PhoneNumber.getToken({ number: fetchNumId });

        let fetchGetFileIdWA = await MessageTemplate.postFileTemplateWA({
          partner_token: key?.token,
          media_url: url.data[0]?.url,
        });

        // console.log('fetchGetFileIdWA', fetchGetFileIdWA);

        setHeader({ ...header, file: fetchGetFileIdWA?.media_id });

        setLoadingUpload(false);
      } catch (e) {
        setLoadingUpload(false);
      }
    };
    await input.click();
  };

  const typeHeader = {
    IMAGE: {
      text: 'Choose Image',
      warning: 'PNG or JPG image format and max size 1.5 MB',
      format: 'image/jpeg,image/png',
    },
    DOCUMENT: {
      text: 'Choose PDF',
      warning: 'PDF format',
      format: 'application/pdf',
    },
    VIDEO: {
      text: 'Choose Video',
      warning: 'MP4 video format and max size 64.0 MB',
      format: 'video/mp4',
    },
    TEXT: {
      text: 'Choose TEXT',
      warning: 'TEXT format',
    },
  };
  return (
    <Stack spacing={2}>
      <Typography paragraph sx={{ fontSize: '0.8em', fontWeight: '700' }}>
        Enter the text for your message in the language you've selected.
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6">Header</Typography>
      </Stack>

      <Stack spacing={0}>
        {header.format === 'TEXT' ? (
          headerSampleCount().map((val, index) => (
            <Stack spacing={0} key={val}>
              <TextField
                label={val}
                value={header.example[index + 1]}
                //   inputRef={bodyRef}
                inputProps={{ maxLength: 1024 }}
                onChange={(e) => {
                  setHeader({
                    ...header,
                    example: { ...header.example, [index + 1]: e.target.value },
                  });
                }}
                error={!header.example[index + 1]}
                helperText={
                  !header.example[index + 1]
                    ? 'Header example is required field'
                    : null
                }
              />
            </Stack>
          ))
        ) : (
          <Box>
            {header.file?.fileName && (
              <Box
                p="10px"
                border="1px solid #cece"
                mb="10px"
                borderRadius="10px"
              >
                <Typography sx={{ fontSize: '14px' }}>
                  {header.file?.fileName}
                </Typography>
              </Box>
            )}

            <Button
              variant="contained"
              onClick={handleUploadClick}
              disabled={loadingUpload}
            >
              {loadingUpload ? 'Loading...' : typeHeader[header.format].text}
            </Button>

            <Typography
              sx={{ mt: '10px', fontSize: '12px', fontWeight: '700' }}
            >
              <Icon icon="mdi:warning-circle" style={{ marginRight: '5px' }} />
              {typeHeader[header.format].warning}
            </Typography>
          </Box>
        )}
        {/* {headerSampleCount().map((val, index) => (
          <Stack spacing={0} key={val}>
            <TextField
              label={val}
              value={header.example[index + 1]}
              //   inputRef={bodyRef}
              inputProps={{ maxLength: 1024 }}
              onChange={(e) => {
                setHeader({
                  ...header,
                  example: { ...header.example, [index + 1]: e.target.value },
                });
              }}
              error={!header.example[index + 1]}
              helperText={
                !header.example[index + 1]
                  ? "Header example is required field"
                  : null
              }
            />
          </Stack>
        ))} */}
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6">Body</Typography>
      </Stack>
      {bodySampleCount().map((val, index) => (
        <Stack spacing={0} key={val}>
          <TextField
            label={val}
            value={body.example[index + 1]}
            //   inputRef={bodyRef}
            inputProps={{ maxLength: 1024 }}
            onChange={(e) => {
              setBody({
                ...body,
                example: { ...body.example, [index + 1]: e.target.value },
              });
            }}
            error={!body.example[index + 1]}
            helperText={
              !body.example[index + 1] ? 'Body example is required field' : null
            }
          />
        </Stack>
      ))}
    </Stack>
  );
}
